import CurrentOrderApp from './App'
import UpcomingOrderApp from './App.upcoming'

export const App = __UPCOMING_ORDER_APP__ ? UpcomingOrderApp : CurrentOrderApp
